import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../../website-utils/meta";
import ScrollToTopOnMount from "../../website-utils/ScrollToTopOnMount";
import logoBlack from '../../assets/images/logo-black.png';
import shiftPageHero from '../../assets/images/ben-jerry.jpg';
import {Link} from "react-router-dom";
import config, {AIRTABLE_HOOKS_ROOT, API_ROOT} from "../../config";


class ShiftPageMookata extends Component {
  constructor(props) {
    super(props);
    this.data = {
      job_type: 'Server',
      business_name: 'Ben and Jerry\'s',
      date: 'Sunday, 12 Aug',
      start_time: '4:30PM',
      end_time: '10:30PM',
      wage: 7,
      neighborhood: 'Holland Village',
      address: '#01-03 Holland Piazza, 3 Lorong Liput, Singapore 277725',
      maps: 'https://goo.gl/maps/kq85168yeK72',
    }
  }

  componentDidMount() {
    window.analytics.page("Shift");
  }

  render() {
    window.prerenderReady = true;

    const {classes} = this.props;

    return (
      <div className={classes.shiftPage}>
        <ScrollToTopOnMount/>
        <Helmet>
          {metaTitles(`${this.data.job_type.toString()} for ${this.data.business_name.toString()}`)}
          {metaDescriptions(`${this.data.job_type.toString()} for ${this.data.business_name.toString()} on ${this.data.date.toString()} from ${this.data.start_time.toString()} to ${this.data.end_time.toString()} in ${this.data.neighborhood.toString()}. SGD ${this.data.wage.toString()} per hour.`)}
          {metaImages(`${window.location.origin}${shiftPageHero}`)}
        </Helmet>
        <div className={classes.header}>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <a href={'https://www.singleshift.sg/pros'}>
                  <img className="logo" src={logoBlack}/>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Image */}
        <div id='hero'>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <img src={shiftPageHero} className='img-fluid' width='940'/>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Information */}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h1 className={classes.shiftName}>{`${this.data.job_type.toString()} for ${this.data.business_name.toString()}`}</h1>
              <p className={classes.shiftDate}>{`${this.data.date.toString()} from ${this.data.start_time.toString()} to ${this.data.end_time.toString()}`}</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Wage</h3>
              <p className={classes.shiftWage}>SGD {`${this.data.wage.toString()}`} per hour</p>
            </div>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Job Type</h3>
              <p className={classes.shiftJob}>{`${this.data.job_type.toString()}`}</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Address</h3>
              <p className={classes.shiftAddress}>{`${this.data.neighborhood.toString()}`} (<a href={`${this.data.maps.toString()}`} target="_blank">{`${this.data.address.toString()}`}</a>)</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Attire</h3>
              <p>Covered shoes and pants/shorts. T-shirt and cap will be provided.</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Duties</h3>
              <p>Scooping and preparing Ben & Jerry's ice cream and engaging guests. Involves giving out some flyers too.</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Comments</h3>
              <p>This is also a trial shift with opportunity to join long term as permanent part timer. On top of free ice cream, we also have other perks. We are looking for individuals with a positive attitude and mindset who love to have fun in the job.</p>
            </div>
          </div>
        </div>

        {/* Shift Actions*/}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Have an account?</h3>
                <p>Reply YES to the SMS you received.</p>
              </div>
            </div>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Don't have an account?</h3>
                <a href={'https://www.singleshift.sg/pros'}>Sign up</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default withStyles((theme) => ({
  header: {
    padding: '20px 0',
  },
  shiftPage: {
    marginBottom: '50px',
    '& p': {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '20px'
    },
  },
  shiftSection: {
    borderBottom: '1px solid #ccc',
    marginBottom: '30px',
    paddingBottom: '10px',
  },
  shiftName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '35px',
    marginTop: '15px',
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '30px',
      lineHeight: '45px',
    },
  },
  shiftLabel: {
    fontSize: '16px',
    lineHeight: '25px',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  shiftBox: {
    border: '1px solid #ccc',
    padding: '15px 10px',
    marginBottom: '20px',
    '& p': {
      marginBottom: '0'
    },
  },
}))(ShiftPageMookata);



// WEBPACK FOOTER //
// ./src/pages/shift-pages/ShiftPageBenJerry76.js